module.exports = __webpack_public_path__ + "static/media/S1.09ea0a43.png";